// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-groups-outer-wrapper{display:flex;padding:5px}.item-groups-flex-wrapper{flex:1}.item-groups-three-col-wrapper{display:flex;flex:1}.item-groups-three-col-left{flex:1;order:1}.item-groups-three-col-center{flex:1;order:2}.item-groups-three-col-right{flex:1;order:3}.item-groups-column-wrapper{display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
